(function () {
  const START_COUNT = 2080;
  const DAILY_GROWTH = 374;
  const MAX_DAYS = 7;
  const START_DATE = new Date('2026-04-26T00:00:00');

  const el = document.getElementById('astos-counter');
  if (!el) return;

  function seededVariation(day) {
    const x = Math.sin((day + 1) * 12.9898) * 43758.5453;
    return Math.floor((x - Math.floor(x)) * 13);
  }

  function formatText(value) {
    return `<span class="member-count">${value.toLocaleString()}</span> Mensen hebben zich al aangemeld`;
  }

  function animateCount(el, target) {
    let current = Math.max(0, target - 120);

    function step() {
      const diff = target - current;

      if (diff <= 1) {
        el.innerHTML = formatText(target);
        return;
      }

      current += Math.max(1, Math.ceil(diff * 0.12));
      el.innerHTML = formatText(Math.floor(current));

      requestAnimationFrame(step);
    }

    step();
  }

  function updateCounter() {
    const now = new Date();
    const diffMs = now - START_DATE;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const clampedDays = Math.max(0, Math.min(diffDays, MAX_DAYS));

    const variation = seededVariation(clampedDays);
    const count = START_COUNT + (clampedDays * DAILY_GROWTH) + variation;

    animateCount(el, count);
  }

  updateCounter();
})();